import React, { FC, useEffect } from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';

import Clear from '../../icons/clear-btn.svg';
import { CustomClearRefinementProps } from './models';

import './CustomClearRefinement.scss';

const ClearRefinements = ({ items, refine, clearBtnText, onHandleClear, isCleared }) => {
  const handleClear = () => {
    refine(items);
    onHandleClear();
  };

  useEffect(() => {
    if (isCleared) {
      handleClear();
    }
  }, [isCleared]);

  return (
    <button
      className="filters__clear"
      id="filters__clear"
      type="button"
      onClick={() => {
        handleClear();
      }}
    >
      <span className="filters__clear-text breadcrumb">{clearBtnText}</span>
      <span className="filters__clear-icon" aria-hidden="true">
        <Clear />
      </span>
    </button>
  );
};

const CustomClearRefinement: FC<CustomClearRefinementProps> = connectSearchBox(ClearRefinements);

export default CustomClearRefinement;
